/**
 * FinaPremises API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createFinaPremise,
  deleteFinaPremise,
  getFinaPremise,
  listFinaPremises,
} from "../generated/fina-premises/fina-premises";

import { wrapMethod } from "./utils";

export const finaPremises = {
  /** @see listFinaPremises */
  listFinaPremises: wrapMethod(listFinaPremises),

  /** @see createFinaPremise */
  create: wrapMethod(createFinaPremise),

  /** @see getFinaPremise */
  getFinaPremise: wrapMethod(getFinaPremise),

  /** @see deleteFinaPremise */
  delete: wrapMethod(deleteFinaPremise),
} as const;

export type FinaPremisesApi = typeof finaPremises;
